import { Badge } from "@ui-library/core";
import { colorPalette } from "@ui-library/myslpro"
import { SkeletonLoaderDiv } from "_shared/styles/skeletonLoader";
import styled from "styled-components";

export const FilterBarWrapper = styled(SkeletonLoaderDiv)`
    ${props => !props.isLoading && 'position: sticky;' };
    display: flex;
    
    top: 80px;
    z-index: 1;
    justify-content: space-between;
    align-items: center;
    background-color: ${colorPalette.cloud};
    border-radius: 15px;
    padding: 15px;
    margin-left: 20px;
    margin-right: 20px;
`;


export const LeftContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`;

export const RightContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledBadge = styled(Badge)`
    margin-right: 0px;
`;